import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteVehicle(uuid: string): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/vehicle/${uuid}`)
}
